export const SYSTEM_ROLES = ['staff', 'api'];
export const SYSTEM_AND_DEMO_ROLES = SYSTEM_ROLES.concat('demo');
export const ROLES_ARRAY = [
  {
    id: 'owner',
    level: 50,
    premium: true,
    name: 'Account Manager',
    plural: 'Account Managers',
    info: 'This role has full access to the team account.',
    setupHelp:
      'have full access to the account including billing and team management. This is typically the Hiring Manager, whether in Recruiting or Engineering.',
    order: 4,
  },
  {
    id: 'inviter',
    level: 10,
    premium: true,
    name: 'Manager',
    plural: 'Managers',
    info: 'This role has full access to the team account except for billing and user management.',
    setupHelp:
      'can view all the {{participants}} in a process and invite new {{participants}}. This role is usually a Team Lead, Recruiter, or Technical Interviewer.',
    order: 3,
  },
  {
    id: 'reviewer',
    level: 5,
    premium: false,
    name: 'Reviewer',
    plural: 'Reviewers',
    info: 'This role is restricted to reviewing {{participants}} only; no manager permissions.',
    setupHelp:
      'have the ability to view all {{participant}} details and review their submissions. This is typically an Engineer, Technical Evaluator or Assistant Recruiter.',
    order: 2,
  },
  {
    id: 'blind_reviewer',
    level: 2,
    premium: false,
    name: 'Blind Reviewer',
    plural: 'Blind Reviewers',
    info: 'This role can review {{participants}} while seeing no personally identifiable information.',
    setupHelp:
      "are Reviewers that can't see personally identifiable details. This removes unconscious bias from the hiring process. It removes race, gender, or other subjective factors, and focuses the {{participant}} review on performance and skill.",
    order: 1,
  },
  {
    id: 'staff',
    level: 100,
    name: 'Staff',
    plural: 'Staff',
    info: "Looks like you're one of us!",
    setupHelp: 'for Qualified internal use only.',
    order: 0,
    hidden: true,
  },
];

export const ROLES = ROLES_ARRAY.reduce((ROLES, r) => {
  ROLES[r.id] = r;
  return ROLES;
}, {});

export const ROLE_GROUPS = [
  {
    id: 'premium',
    name: 'Premium',
    roles: ROLES_ARRAY.filter((r) => r.premium === true).map((r) => r.id),
  },
  {
    id: 'restricted',
    name: 'Restricted',
    roles: ROLES_ARRAY.filter((r) => r.premium === false).map((r) => r.id),
  },
];
